export enum DialogSizeEnum {
    SMALL = '480px',
    MEDIUM = '720px',
    LARGE = '1020px',
}
